import React, { useState, useEffect } from 'react'
import cx from 'classnames'

import { useDispatch } from 'react-redux'
import { increaseQuantity, decreaseQuantity } from 'actions'
import { MinusIcon, PlusIcon } from 'components/common'
import s from './Cart.module.css'

const CartInputRow = ({ item, removeItemFromCart, disableIncreaseButton }) => {
  const [inputValue, setInputValue] = useState(item.quantity)

  useEffect(() => {
    setInputValue(item.quantity)
  }, [item.quantity])

  const dispatch = useDispatch()

  const decreaseItemHandler = () => {
    if (inputValue === 1) {
      removeItemFromCart()
    } else {
      setInputValue(inputValue - 1)
      dispatch(decreaseQuantity(item.id))
    }
  }

  const increaseItemHandler = () => {
    if (disableIncreaseButton) {
      return
    }

    setInputValue(inputValue + 1)
    dispatch(increaseQuantity(item.id))
  }

  const increaseButtonClass = cx(s.increase, {
    [s['increase--disabled']]: disableIncreaseButton
  })

  return (
    <div className={s.valueRow}>
      <MinusIcon className={s.decrease} onClick={decreaseItemHandler}>
        -
      </MinusIcon>

      <input className={s.increaseInput} value={inputValue} readOnly />

      <PlusIcon className={increaseButtonClass} onClick={increaseItemHandler}>
        +
      </PlusIcon>
    </div>
  )
}

export default CartInputRow
